import React from 'react';

export default class IdNameEntity {

  static shape = {
    id: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
  };

  constructor(item) {
    Object.assign(this, item);
  }

  get text() {
    return this.name;
  }

}



// WEBPACK FOOTER //
// ./shared/src/entity/IdNameEntity.js